import axios from 'axios';
import {apiBaseUrl} from '../../../helpers/UrlHelper'
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {handleError} from '../../../helpers/ErrorHelper'

function _success(success) {
    return {type: 'GET_CUSTOMER_ROLES_SUCCESS', success};
}

function _error(error) {
    return {type: 'GET_CUSTOMER_ROLES_ERROR', error};
}

function _processing(processing) {
    return {type: 'GET_CUSTOMER_ROLES_PROCESSING', processing};
}

function getCustomerRoles() {
    return (dispatch) => {
        dispatch(_processing(true));

        const request = axios({

            url: apiBaseUrl(`admin/customers/roles`),
            method: "get",
            dataType: 'json',
            headers: {
                'Authorization': 'Bearer ' + loginToken()
            }
        })
            .then(function (res) {
                dispatch(_success(res?.data?.data?.data));
                dispatch(_processing(false));

            }).catch(function (error) {
                dispatch(_error(error));
                dispatch(_processing(false));
                handleError(error)

            });

        return {
            type: 'GET_CUSTOMER_ROLES_SUCCESS',
            payload: request
        }
    }
}

export default getCustomerRoles;